import { MAX_POSITIVE_INT, MAX_POSITIVE_INT_LENGTH } from "../utils/general";

//Mock Data
export const mockData = Array.from({ length: 50 }, (_, index) => ({
  action: `ACTION_${String(index + 1).padStart(3, "0")}`, // unique
  config: {
    maxPerDay: (index % 5) + 1, // varies between 1–5
    minRewardIntervalInMinutes: 120 + index * 5
  },
  reward: {
    fixed: 10 + (index % 5) * 5,
    expiryInDays: 10 + (index % 10),
  },
  enabled: index % 2 === 0, // true/false alternates
}));

export const LOYALTY_SPEC_NAME = "Loyalty Spec"
export const LOYALTY_SPEC_DESC = "Manage reward configurations"

// Table columns configuration
export const columnsData = [
  {
    key: "action",
    label: "Action Id",
    sortable: true,
  },
  {
    key: "fixed",
    label: "Reward",
    sortable: true,
  },
  {
    key: "expiryInDays",
    label: "Expiry (In Days)",
    sortable: true,
  },
  {
    key: "config",
    label: "Config",
    sortable: false,
  },
  {
    key: "actions",
    label: "Action",
    sortable: false,
  },
];

export const constStyles = {
  fontW: {
    fontWeight500: 500,
    fontWeight600: 600,
    fontWeight700: 700,
  },
  fontSz: {
    fontSz24: "1.5rem",
    fontSz18: "1.125rem",
    fontSz16: "1rem",
    fontSz14: ".875rem",
  },
  borderSz: {
    border1px: "1px solid ",
    border2px: "2px solid ",
  },
  borderRd:{
    borderRd4px: "4px",
    borderRd8px: "8px",
    borderRd16px: "16px",
  },
  constColours: {
    primary: {
      main: "#1976D2",
      light: "#42A5F5",
      dark: "#1565C0",
      contrastText: "#FFFFFF",
      bg: "#E3F2FD",
    },
    secondary: {
      main: "#9C27B0",
      light: "#BA68C8",
      dark: "#7B1FA2",
      contrastText: "#FFFFFF",
      bg: "#F3E5F5",
    },
    info: {
      main: "#0288D1",
      light: "#03A9F4",
      dark: "#01579B",
      contrastText: "#FFFFFF",
      bg: "#E1F5FE",
    },
    success: {
      main: "#2E7D32",
      light: "#4CAF50",
      dark: "#1B5E20",
      contrastText: "#FFFFFF",
      bg: "#E8F5E9",
    },
    warning: {
      main: "#ED6C02",
      light: "#FF9800",
      dark: "#E65100",
      contrastText: "#FFFFFF",
      bg: "#FFF3E0",
    },
    error: {
      main: "#D32F2F",
      light: "#EF5350",
      dark: "#C62828",
      contrastText: "#FFFFFF",
      bg: "#FFEBEE",
    },
    disabled: {
      main: "#9E9E9E",
      light: "#E0E0E0",
      contrastText: "#BDBDBD",
      bg: "#F5F5F5",
    },
    ghost: {
      main: "#424242",
      light: "#757575",
      contrastText: "#212121",
      bg: "#EEEEEE",
    },
  },
};


/**
 * Add New Spec Constant
 */

export const getPositiveIntegerSlotProps = (extraProps = {}) => ({
  htmlInput: {
    inputMode: 'numeric',
    pattern: '[0-9]*',
    // min: 1,
    // step: 1,
    // max: MAX_POSITIVE_INT,
    maxLength: MAX_POSITIVE_INT_LENGTH - 1,
    ...extraProps,
  },
});

// export const blockInvalidNumberKeys = (e) => {
//   if (['e', 'E', '+', '-', '.'].includes(e.key)) {
//     e.preventDefault();
//   }
// };

export const blockInvalidNumberKeys = (e) => {
  // if (!/^\d$/.test(e.key) && e.key !== "Backspace" && e.key !== "Tab") {
  //   e.preventDefault();
  // }

  // Allow modifier combos (paste/shortcuts) and common navigation/edit keys
  if (e.ctrlKey || e.metaKey) return;
  if (/^\d$/.test(e.key) || ["Backspace", "Tab", "ArrowLeft", "ArrowRight", "Delete", "Home", "End"].includes(e.key)) {
    return;
  }
  e.preventDefault();
};

/**
 * Delete, Disable and Enable constant
 */

export const DELETE_TYPE_NAME = "delete";
export const ENABLE_DISABLE_TYPE_NAME = "toggle";